import { defineNuxtRouteMiddleware } from '#imports'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'

export default defineNuxtRouteMiddleware(async () => {
  const userStore = useUserStore()

  if (!userStore.fetched) {
    await userStore.fetchUser()
  }
})
